import { LinearProgress, LinearProgressProps } from '@mui/material';

import linearProgressTheme from './LinearProgress';

export { linearProgressTheme };
export default LinearProgress;
export type { LinearProgressProps };
